import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from './plugins/axios';
import VueClipboard from 'vue-clipboard2';
import './common/font.css';
import './common/yourslink_theme.scss';
import PrerenderHelper from './utils/PrerenderHelper';
import { preloadCriticalFonts, scheduleDeferFonts } from './utils/fontLoader';
import throttleDirective from './directives/throttle';

Vue.use(VueClipboard);

// 只导入Tailwind的基础样式，组件和工具类会通过purge自动包含
import "tailwindcss/base.css"
import "tailwindcss/components.css"
import "tailwindcss/utilities.css"

// 预加载关键字体（Regular）
if (typeof window !== 'undefined') {
  preloadCriticalFonts();
}


// import ElementUI from 'element-ui';
// import lang from 'element-ui/lib/locale/lang/en';
// ElementUI.locale(lang);

import './assets/css/element-variables.scss'

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
locale.use(lang)

// 按需引入 ElementUI 全局组件
import {
  Form,
  FormItem,
  Select,
  Option,
  Input,
  Button,
  Checkbox,
  Image,
  Pagination,
  DatePicker,
  Upload,
  Dialog,
  Row,
  Col,
  Radio,
  Skeleton,
  SkeletonItem,
  Message,
  MessageBox,
} from 'element-ui';

Vue.use(Form);
Vue.use(FormItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(Image);
Vue.use(Pagination);
Vue.use(DatePicker);
Vue.use(Upload);
Vue.use(Dialog);
Vue.use(Row);
Vue.use(Col);
Vue.use(Radio);
Vue.use(Skeleton);
Vue.use(SkeletonItem);


import NavComponent from './components/NavComponent.vue';
import FooterComponent from './components/FooterComponent.vue';
import UploaderComponent from './components/UploaderComponent.vue';
import ContactComponent from "@comps/ContactComponent.vue";
import ProgressiveImage from "@comps/ProgressiveImage.vue";
import CompHouseCard from "@comps/CompHouseCard.vue";

Vue.component('NavComponent', NavComponent);
Vue.component('FooterComponent', FooterComponent);
Vue.component('ProgressiveImage', ProgressiveImage);
Vue.component('c-uploader', UploaderComponent);
Vue.component('c-contact', ContactComponent);
Vue.component('CompHouseCard', CompHouseCard);

Vue.prototype.$result = { type: 'success', title: 'Success', note: 'Operation successful' }
Vue.prototype.$fail = Message.warning;
Vue.prototype.$message = Message;
Vue.prototype.$box = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;

import * as dataService from './plugins/dataService.js'
Vue.prototype._ = dataService;

import { baseUrl } from '@/plugins/dataService.js';
import api from '@/plugins/api.js';

Vue.prototype.url = baseUrl;
Vue.prototype.axios = axios;
Vue.prototype.$axios = axios;
// 组件里面: this.$axios;
window.axios = axios; //组件，非组件里面都可以  axios()
Vue.prototype.$api = api;
Vue.config.productionTip = false;

router.afterEach((to) => {
  window.scrollTo(0, 0);

  Vue.nextTick(() => {
    if (Vue.prototype.$prerender && typeof Vue.prototype.$prerender.ensureRouteSEO === 'function') {
      Vue.prototype.$prerender.ensureRouteSEO(to);
    }
  });
});



Vue.directive('throttle', throttleDirective);

Vue.filter('formatThousandsSeparator', function (num) {
  if (num == null || isNaN(num)) return '0.00';
  const multiplier = 100;
  const roundedNum = Math.round(Number(num) * multiplier) / multiplier;
  const parts = roundedNum.toFixed(2).split('.');
  let intPart = parts[0];
  const decimalPart = parts[1];

  /** @type {Record<number, string>} */
  const prefixMap = {
    0: '',
    2: '0',
    1: '00',
  };
  const str = prefixMap[intPart.length % 3] + intPart;
  const list = str.match(/.{1,3}/g) || [];
  list[0] = String(parseInt(list[0] ?? ''));
  const formattedInt = list.join(',');

  // return formattedInt + '.' + decimalPart;
  return formattedInt;
});

// 全局注册预渲染工具
Vue.prototype.$prerender = PrerenderHelper;

// 全局错误处理器 - 捕获 Vue 组件内的错误
Vue.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err);
  console.error('Component:', vm);
  console.error('Error Info:', info);
  // 防止错误导致应用崩溃
  return false;
};

// 全局警告处理器 - 开发环境
if (process.env.NODE_ENV === 'development') {
  Vue.config.warnHandler = (msg, vm, trace) => {
    console.warn('Vue Warning:', msg);
    console.warn('Trace:', trace);
  };
}

// 捕获未处理的 Promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled Promise Rejection:', event.reason);
  event.preventDefault();
});

// 捕获全局错误
window.addEventListener('error', (event) => {
  console.error('Global Error:', event.error);
  event.preventDefault();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted () {
    // 依赖异步数据的详情页由页面自身在数据就绪后触发 render-event
    if (!this.$prerender.needsAsyncPrerenderData()) {
      this.$prerender.triggerRenderEvent();
    }

    this.$prerender.clientOnly(() => {
      // 空闲时延迟加载非关键字体（Light/Medium/Bold/Heavy）
      scheduleDeferFonts();
    });
  }
}).$mount('#app');
